import { useForm, Controller } from 'react-hook-form';
import { PrimaryButton, SecondaryButton, Select } from '@weareopenr/component-library';
import { IPublishFormValues, Steps } from '../../types';
import { ButtonContainer } from '../../../ButtonContainer/ButtonContainer';
import { ModalTitle } from '../../../ModalTitle/ModalTitle';
import { usePriceSchemes } from 'src/hooks/usePriceSchemes';

export const SelectPriceScheme = ({
  defaultValues,
  submitDataToParent,
}: {
  defaultValues: Pick<IPublishFormValues, 'priceSchemeId'>;
  submitDataToParent: (data: Partial<IPublishFormValues>, nextStep?: number) => void;
}) => {
  const { data: priceSchemes = [], isLoading: isPriceSchemesLoading } = usePriceSchemes();
  const { control, handleSubmit, watch } = useForm<Pick<IPublishFormValues, 'priceSchemeId'>>({
    defaultValues: {
      priceSchemeId: defaultValues.priceSchemeId,
    },
  });

  const priceSchemeId = watch('priceSchemeId');

  const priceSchemeOptions = priceSchemes.map((scheme) => ({
    value: scheme.id,
    name: scheme.name,
  }));

  const onSubmit = (data: Pick<IPublishFormValues, 'priceSchemeId'>) => {
    submitDataToParent(data, Steps.venues);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ModalTitle title="Price Scheme" subTitle="Choose which price scheme to use for this publication." />
      <Controller
        name="priceSchemeId"
        control={control}
        rules={{ required: 'Please select a price scheme' }}
        render={({ field, fieldState: { error } }) => (
          <Select
            label="Price Scheme"
            loading={isPriceSchemesLoading}
            disabled={isPriceSchemesLoading}
            options={priceSchemeOptions}
            value={field.value}
            onChange={field.onChange}
            error={error?.message}
          />
        )}
      />
      <ButtonContainer
        left={
          <SecondaryButton onClick={() => submitDataToParent({}, Steps.type)} size="full-width" buttonStyle="outline">
            Back
          </SecondaryButton>
        }
        right={
          <PrimaryButton type="submit" size="full-width" disabled={!priceSchemeId}>
            Continue
          </PrimaryButton>
        }
      />
    </form>
  );
};
